var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreenBlob = function SvgGreenBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 706,
    height: 568,
    viewBox: "0 0 706 568",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M542.152 196.335C189.377 -8.12026 -72.6187 122.587 141.117 410.29C354.853 697.992 515.645 510.335 542.152 478.533C568.66 446.732 894.928 400.79 542.152 196.335Z",
    fill: "transparent",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M440.46 93.8639C340.308 -153.136 64.5421 136.444 39.4249 396.654C14.3076 656.864 328.113 569.431 440.46 464.898C552.808 360.364 540.613 340.864 440.46 93.8639Z",
    fill: "transparent",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M423.719 115.511C91.7592 -26.8528 -61.3912 157.455 22.684 418.301C106.759 679.147 522.912 522.834 635.259 418.301C747.607 313.767 755.68 257.875 423.719 115.511Z",
    fill: "transparent",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABDBD5",
    fillOpacity: 0.25
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "20s",
    repeatCount: "indefinite",
    values: "M542.152 196.335C189.377 -8.12026 -72.6187 122.587 141.117 410.29C354.853 697.992 515.645 510.335 542.152 478.533C568.66 446.732 894.928 400.79 542.152 196.335Z;M423.719 115.511C91.7592 -26.8528 -61.3912 157.455 22.684 418.301C106.759 679.147 522.912 522.834 635.259 418.301C747.607 313.767 755.68 257.875 423.719 115.511Z;M440.46 93.8639C340.308 -153.136 64.5421 136.444 39.4249 396.654C14.3076 656.864 328.113 569.431 440.46 464.898C552.808 360.364 540.613 340.864 440.46 93.8639Z;M542.152 196.335C189.377 -8.12026 -72.6187 122.587 141.117 410.29C354.853 697.992 515.645 510.335 542.152 478.533C568.66 446.732 894.928 400.79 542.152 196.335Z;"
  }))));
};
export default SvgGreenBlob;